import { render, staticRenderFns } from "./CurrentOffers.vue?vue&type=template&id=233f00ea&scoped=true"
import script from "./CurrentOffers.vue?vue&type=script&lang=ts"
export * from "./CurrentOffers.vue?vue&type=script&lang=ts"
import style0 from "./CurrentOffers.vue?vue&type=style&index=0&id=233f00ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f00ea",
  null
  
)

export default component.exports